/**
 * @param {object | null | undefined} order
 * @returns {boolean}
 */
export function orderNeedsEmailVerification(order) {
  return Boolean(order && order.needsEmailVerification === true);
}

/**
 * Next step after payment, from GET /api/pedidos/:id/status.
 * `accessMode` is code, login, or course. When it is missing, keep the
 * previous rule: a verification code only if needsEmailVerification is true.
 * @param {object | null | undefined} order
 * @returns {"code" | "login" | "course"}
 */
export function resolvePaidOrderAccess(order) {
  const accessMode = order && typeof order.accessMode === "string" ? order.accessMode : "";
  if (accessMode === "code" || accessMode === "login" || accessMode === "course") {
    return accessMode;
  }
  return orderNeedsEmailVerification(order) ? "code" : "course";
}

/**
 * @param {object | null | undefined} order
 * @param {string} orderId
 * @returns {{ pathname: string, search: string, state: { email: string, pedidoId: string } }}
 */
export function buildCheckEmailFromCheckout(order, orderId) {
  const email = typeof order?.buyerEmail === "string" ? order.buyerEmail.trim() : "";
  const pedidoId = typeof orderId === "string" ? orderId : "";
  const search = pedidoId ? `?orderId=${encodeURIComponent(pedidoId)}` : "";
  return {
    pathname: "/check-email",
    search,
    state: { email, pedidoId },
  };
}
